export default Object.freeze({
  POSTINGS: 'compliance',
  MINWAGE: 'minwage',
  PAID_LEAVE: "paidLeave"
})
